export default __webpack_public_path__ + "static/media/compiegne17.6c205e61.jpg";